import React from 'react';
import { Resource, Title, useGetList } from 'react-admin';
import {
  Box,
  Card,
  CardContent,
  MenuItem,
  TextField,
  Typography,
} from '@material-ui/core';
import { useTokenOps } from '../components/TokenContext';
import CircularityMetricsSection from './project/components/CircularityMetricsSection';

export const CircularityDashboardPage = () => {
  const tokenOps = useTokenOps();
  const accountId = tokenOps.account?.data?.accountId;
  const accessToken = tokenOps.account?.accessToken;
  const [selectedProjectId, setSelectedProjectId] = React.useState('');
  const {
    data: projectsById = {},
    ids: projectIds = [],
    loading: projectsLoading,
    error: projectsError,
  } = useGetList(
    'projects',
    { page: 1, perPage: 1000 },
    { field: 'name', order: 'ASC' },
    { accountId },
  );
  const projects = projectIds
    .map((id) => projectsById[id])
    .filter(Boolean);
  const selectedProjectIsAvailable = projects.some(
    (project) => project.id === selectedProjectId,
  );
  const displayedProjectId = selectedProjectIsAvailable
    ? selectedProjectId
    : '';
  const selectorDisabled =
    projectsLoading || Boolean(projectsError) || projects.length === 0;
  const projectHelperText = projectsLoading
    ? 'Loading projects...'
    : projectsError
      ? 'Unable to load projects.'
      : projects.length === 0
        ? 'No projects available for this account.'
        : 'Select the project whose Circularity dashboard you want to view.';

  React.useEffect(() => {
    setSelectedProjectId('');
  }, [accountId]);

  return (
    <>
      <Title title="Circularity Dashboard" />
      <Card>
        <CardContent>
          <Box maxWidth={520} marginBottom={selectedProjectIsAvailable ? 1 : 3}>
            <TextField
              select
              id="circularity-dashboard-project"
              label="Project"
              value={displayedProjectId}
              onChange={(event) => setSelectedProjectId(event.target.value)}
              variant="outlined"
              margin="dense"
              fullWidth
              disabled={selectorDisabled}
              helperText={projectHelperText}
              InputLabelProps={{ shrink: true }}
              SelectProps={{
                displayEmpty: true,
                renderValue: (value) =>
                  value
                    ? projects.find((project) => project.id === value)?.name
                    : 'Select a project',
              }}
            >
              <MenuItem value="" disabled>
                Select a project
              </MenuItem>
              {projects.map((project) => (
                <MenuItem key={project.id} value={project.id}>
                  {project.name}
                </MenuItem>
              ))}
            </TextField>
          </Box>

          {!selectedProjectIsAvailable && !selectorDisabled && (
            <Typography color="textSecondary">
              Select a project to view its Circularity metrics.
            </Typography>
          )}

          {selectedProjectIsAvailable && (
            <CircularityMetricsSection
              projectId={selectedProjectId}
              accessToken={accessToken}
            />
          )}
        </CardContent>
      </Card>
    </>
  );
};

const circularityDashboardResource = () => (
  <Resource
    name="circularity-dashboard"
    options={{ label: 'Circularity Dashboard', menuGroup: 'Projects' }}
    list={CircularityDashboardPage}
  />
);

export default circularityDashboardResource;
